const languages = [
  'nodejs',
  'python3',
  'java',
  'c',
  'c++',
  'c#',
  'ruby',
  'php',
  'swift',
  'kotlin',
  'go',
  'rust',
  'typescript',
  'dart',
  'scala',
  'perl',
  'r',
  'matlab',
  'shell',
  'sql',
  'html',
  'css',
  'objective-c',
  'vb.net',
  'f#',
  'groovy',
  'haskell',
  'lua',
  'erlang',
  'elixir',
  'julia',
  'clojure',
  'assembly',
  'ada',
  'fortran',
  'cobol',
  'pascal',
  'lisp',
  'prolog',
  'scheme',
  'ocaml',
  'vhdl',
  'verilog',
  'd',
  'nim',
  'crystal',
  'elm',
  'purescript',
  'reason',
  'solidity',
  'abap',
  'apex',
  'pl/sql',
  'tcl',
  'smalltalk',
  'postscript',
  'awk',
  'actionscript',
  'coldfusion',
  'labview',
  'qml',
  'vala',
  'zig',
];

export default languages;
